<!-- 收货地址 -->
<template>
	<div class="wrap">

		<div class="rightsidebar">
			<p class="rightsidebar-title">收货地址</p>
			<ul class="select-address-list">
				<li :class="{active: item.is_mr }" v-for="(item, index) in list" :key="index">
					<div class="select-address-sidebar">
						<p class="people-name" @click="changeApproveDelivery(item)">{{item.name}}</p>
						<p class="addrss-box">
							<span class="addrss-msg">
								{{item.pro_name}}
								{{item.city_name}}
								{{item.county_name}}
								{{item.street_name}}
								{{item.detail}}
							</span>
							<span class="people-phone-num">{{item.phone}}</span>
						</p>
					</div>
					<div class="select-address-btn-box">
						<button type="button" @click="del(item.id)">删除</button>
						<button type="button" @click="currentEditId = item.id; dialogFormVisible = true">修改</button>
					</div>
				</li>
				<!-- 无内容时显示 -->
				<div class="normal-box" v-if="list.length == 0">
					<img src="../../assets/normal-3.png">
					暂无收货地址
					<button type="button" @click="currentEditId = 0; dialogFormVisible = true">
						<img src="../../assets/add-icon2.png">
						添加收货地址
					</button>
				</div>
				<div class="normal-box" v-else style="padding: 10px 0">
					<button type="button" @click="currentEditId = 0; dialogFormVisible = true">
						<img src="../../assets/add-icon2.png">
						添加收货地址
					</button>
				</div>
			</ul>
		</div>
		<!-- 新增/修改 地址弹窗-->
		<address-add v-model="dialogFormVisible" :add_id="currentEditId" @save="addressAddSave"></address-add>
	</div>
</template>

<script>
	import Header from '../../components/header.vue';
	import Footer from '../../components/footer.vue';
	import { userManageChangeApproveDelivery, userManageDelDeliveryAddress, userManageGetDeliveryAddressList } from '../../service/service';
	import { listenerScrollToBottom } from '../../utils/util';
	import AddressAdd from '../../components/address-add.vue';
	export default {
		components: {
			Header,
			Footer,
			AddressAdd
		},
		data() {
			return {
				form: {
					username: '',
					phone_number: '',
					region: '',
					region2: '',
					region3: '',
					desc: '',
				},

				list: [],
				page: 1,
				page_num: 20,

				//修改&&新增弹窗
				dialogFormVisible: false,
				currentEditId: 0,
			};
		},
		mounted() {
			this.getList();
			// 监听滚动到底部
			listenerScrollToBottom(() => this.getList());
		},
		methods: {

			selectAddress(address) {
				if (this.isSelect == 1) {
					const eventChannel = this.getOpenerEventChannel();
					eventChannel.emit('selectAddress', address);
					uni.navigateBack({
						delta: 1
					});
				}
			},
			addressAddSave(success) {
				if (success) {
					this.page = 1;
					this.getList();
				}
			},
			// 获取列表
			getList() {
				const {page, page_num} = this;
				const params = {
					page,
					page_num,
				};
				userManageGetDeliveryAddressList(params).then(({code, msg, data}) => {
					if (code === 1) {
						const list = data.list.map(item => {
							const [first_name, ...last_name] = item.name.split('');
							item['first_name'] = first_name;
							item['last_name'] = last_name.join('');
							return item;
						});
						this.list = page > 1 ? [...this.list, ...list] : list;
						if (list.length === 0) {
							this.$message.info('没有更多数据了');
						} else {
							this.page = this.page + 1;
						}
					} else {
						this.$message.info(msg);
					}
				})
			},
			
			/**
			 * 修改默认收货地址
			 */
			changeApproveDelivery(item) {
				this.$confirm('确认设为默认地址?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					userManageChangeApproveDelivery({ id: item.id }).then(({code, msg}) => {
						if (code == 1) {
							this.list.forEach(item => item.is_mr = 0);
							item.is_mr = 1;
							this.$message.success(msg);
						} else {
							this.$message.info(msg);
						}
					});
				});
			},
			/**
			 * 跳转新建收货地址
			 */
			add(id = 0) {
				uni.navigateTo({
					url: '/subpack_my/pages/add-address/add-address' + '?id=' + id,
				});
			},
			// 确认删除
			del(id) {
				this.$confirm('确认删除吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					userManageDelDeliveryAddress({ id }).then(({code, msg, data}) => {
						if (code == 1) {
							this.page = 1;
							this.getList();
							document.documentElement.scrollTop = 0;
							this.$message.success(msg);
						} else {
							this.$message.info(msg);
						}
					});
				});
			},
		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		margin: 0 !important;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.top {
		width: 1200px;
		height: 76px;
		line-height: 76px;
		background-color: #FFFFFF;
		border-radius: 8px;
		display: flex;
		align-items: center;
		padding: 0 19px;
		box-sizing: border-box;
		color: #484848;
		font-size: 20px;
		margin: 20px 0;
	}

	.top-icon {
		width: 10px;
		margin: 0 10px;
	}

	.top-name {
		color: #F2501A;
	}

	.container {
		width: 1200px;
		display: flex;
		align-items: flex-start;
		margin-bottom: 43px;
	}

	.leftsidebar {
		width: 144px;
		padding: 21px 0 28px;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 8px;
		margin-right: 19px;
	}

	.leftsidebar>a {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 20px;
		padding: 0 0 0 29px;
		box-sizing: border-box;
		color: #000000;
		font-size: 16px;
		position: relative;
	}

	.leftsidebar>a.active {
		color: #F2501A;
		font-size: 18px;
	}

	.leftsidebar>a.active::after {
		content: "";
		position: absolute;
		left: 0;
		top: 50%;
		transform: translate(0, -50%);
		width: 4px;
		height: 26px;
		background: url(../../assets/border.png) no-repeat;
		background-size: 100% 100%;
	}

	.sanjiao {
		width: 14px;
		margin-left: 10px;
	}

	.rightsidebar {
		width: calc(100% - 0px);
		min-height: 600px;
		display: flex;
		flex-direction: column;
		background-color: #fff;
		border-radius: 8px;
		margin-bottom: 10px;
	}

	.rightsidebar-title {
		width: 100%;
		height: 69px;
		padding: 0 20px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #111111;
		font-size: 20px;
		font-weight: bold;
	}

	.select-address-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 20px 20px 20px;
		box-sizing: border-box;
	}

	.select-address-list>li {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
	}

	.select-address-list>li:last-child {
		margin-bottom: 0;
	}

	.select-address-sidebar {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.people-name {
		min-width: 93px;
		padding: 0 10px;
		box-sizing: border-box;
		height: 44px;
		line-height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #484848;
		font-size: 16px;
		position: relative;
		border-radius: 5px;
		overflow: hidden;
	}

	.addrss-box {
		flex: 1;
		display: flex;
		align-items: center;
		margin-left: 16px;
	}

	.addrss-msg {
		color: #484848;
		font-size: 16px;
	}

	.people-phone-num {
		color: #484848;
		font-size: 16px;
		margin-left: 20px;
	}

	.select-address-btn-box {
		display: flex;
		align-items: center;
	}

	.select-address-btn-box>button {
		font-size: 16px;
		color: #777777;
		margin-right: 20px;
	}

	.select-address-btn-box>button:last-child {
		margin-right: 0;
		color: #F2501A;
	}

	.select-address-list>li.active .people-name {
		border: 1px solid #E63D23;
	}

	.select-address-list>li.active .people-name::after {
		content: "";
		width: 25px;
		height: 25px;
		background: url(../../assets/icon-24.png) no-repeat;
		background-size: 100% 100%;
		position: absolute;
		right: 0;
		bottom: 0;
	}

	.select-address-list>li.active .addrss-msg {
		color: #F2501A;
	}

	.select-address-list>li.active .people-phone-num {
		color: #F2501A;
	}

	.row-start {
		width: 100%;
		display: flex;
		align-items: flex-start;
		margin-bottom: 20px;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.row-start-label {
		width: 126px;
		line-height: 30px;
		color: #000000;
		font-size: 16px;
	}

	.row-start-label>span {
		margin-right: 7px;
	}

	.address-bottom {
		width: 100%;
		border-radius: 8px;
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
	}

	>>>.el-input__inner {
		height: 40px !important;
		line-height: 40px !important;
		/* border: 1px solid #BBBBBB !important; */
		color: #111111;
		font-size: 16px !important;
	}

	>>>.el-input__icon {
		line-height: 30px !important;
	}

	>>>.el-textarea__inner {
		height: 162px !important;
		border: 1px solid #BBBBBB !important;
		color: #111111;
		font-size: 16px;
	}

	.select-item {
		width: 174px;
	}

	.flex-end-box {
		margin-left: 126px;
	}

	.form-bottom {
		display: flex;
		align-items: center;
		color: #000000;
		font-size: 18px;
	}

	input[type="checkbox"] {
		width: 15px !important;
		height: 15px !important;
		vertical-align: middle;
		-webkit-appearance: none;
		background: url(../../assets/square.png) no-repeat center center;
		background-size: 100% 100%;
		margin-right: 5px;
		margin-top: 3.5px;
	}

	input[type="checkbox"]:checked {
		background: url(../../assets/square-active.png) no-repeat center center;
		background-size: 100% 100%;
	}

	.form-btn-box {
		width: 100%;
		display: flex;
		align-items: center;
		padding-bottom: 20px;
	}

	.form-btn-box>button {
		font-size: 17px;
		margin-right: 18px;
	}

	.form-btn-box>button:last-child {
		border: 1px solid #E63D23;
		background-color: #FFFFFF;
		color: #F2501A;
	}

	.privacy-policy-module {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: #FFFFFF;
		border-radius: 8px;
		padding: 23px 30px;
		box-sizing: border-box;
		font-size: 14px;
		color: #111111;
	}

	.logout-btn-box.center {
		justify-content: center;
	}

	.normal-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #999999;
		font-size: 13px;
		padding: 100px 0;
	}

	.normal-box>img {
		width: 42%;
		margin-bottom: 6px;
	}

	.normal-box>button {
		width: 216px;
		height: 45px;
		line-height: 45px;
		border-radius: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #F2501A;
		box-sizing: border-box;
		color: #fff;
		font-size: 14px;
		margin-top: 50px;
	}

	.normal-box>button img {
		width: 19px;
		height: 19px;
		margin-right: 7px;
	}

	>>>.el-dialog__header {
		padding: 15px 17px 15px !important;
		background-color: #F9F9F9 !important;
	}

	.el-dialog__headerbtn>>>.el-dialog__close {
		color: #777777 !important;
	}

	>>>.el-dialog {
		width: 812px !important;
		position: fixed !important;
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
		margin: 0 !important;
		border-radius: 8px !important;
		overflow: hidden !important;
	}

	>>>.el-dialog__body {
		padding: 36px 0 41px !important;
	}

	.form-row-start {
		width: 100%;
		display: flex;
		align-items: flex-start;
		margin-bottom: 15px;
	}

	.form-row-start-label {
		width: 141px;
		text-align: right;
		line-height: 40px;
		color: #111111;
		font-size: 18px;
		padding-right: 16px;
		box-sizing: border-box;
	}

	.form-row-start-label>span {
		margin-right: 6px;
	}

	.form-row-sidebar {
		width: 205px;
		display: flex;
		align-items: center;
	}

	.select-item-2 {
		width: 174px;
	}

	.form-flex-end-box {
		margin-left: 141px;
	}

	.form-bottom-2 {
		display: flex;
		align-items: center;
		color: #777777;
		font-size: 15px;
	}

	.form-bottom-2 input[type="checkbox"] {
		width: 14px !important;
		height: 14px !important;
		vertical-align: middle;
		-webkit-appearance: none;
		background: url(../../assets/circle.png) no-repeat center center;
		background-size: 100% 100%;
		margin-right: 13px;
		margin-top: 1.5px;
	}

	.form-bottom-2 input[type="checkbox"]:checked {
		background: url(../../assets/circle-active.png) no-repeat center center;
		background-size: 100% 100%;
	}

	.form-btnBox-2 {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.form-btnBox-2>button {
		width: 104px;
		height: 34px;
		line-height: 34px;
		background-color: #F2501A;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 18px;
		color: #FFFFFF;
		margin-right: 14px;
	}

	.form-btnBox-2>button:last-child {
		border: 1px solid #DCDCDC;
		background-color: #FFFFFF;
		color: #777777;
	}

	.red-color {
		color: #F2501A;
	}
</style>
